var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5C6.01664 0.5 4.56659 0.939867 3.33323 1.76398C2.09986 2.58809 1.13856 3.75943 0.570907 5.12987C0.0032497 6.50032 -0.145275 8.00832 0.144114 9.46318C0.433503 10.918 1.14781 12.2544 2.1967 13.3033C3.2456 14.3522 4.58197 15.0665 6.03682 15.3559C7.49168 15.6453 8.99968 15.4968 10.3701 14.9291C11.7406 14.3614 12.9119 13.4001 13.736 12.1668C14.5601 10.9334 15 9.48336 15 8C14.9978 6.01157 14.2069 4.10522 12.8008 2.69918C11.3948 1.29315 9.48843 0.50225 7.5 0.5ZM1.5 8C1.49905 6.87721 1.81341 5.77673 2.40731 4.82387C3.0012 3.87101 3.85074 3.10408 4.85918 2.61042C5.86762 2.11677 6.99442 1.91623 8.11126 2.03165C9.2281 2.14706 10.2901 2.5738 11.1763 3.26325L2.76325 11.6762C1.94368 10.6262 1.499 9.33206 1.5 8ZM7.5 14C6.16837 14.0007 4.87475 13.5561 3.825 12.7367L12.2368 4.325C12.9258 5.21118 13.3523 6.27304 13.4675 7.38968C13.5827 8.50632 13.3821 9.63288 12.8885 10.6411C12.3949 11.6493 11.6281 12.4987 10.6754 13.0925C9.7228 13.6863 8.62257 14.0008 7.5 14Z",
    fill: "#DE1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCross);
export default __webpack_public_path__ + "static/media/circleCross.f5fbffe24633adca3963f3dab8772f2c.svg";
export { ForwardRef as ReactComponent };